import React from 'react';
import { Row, Col } from 'antd';

import { useHistory, useLocation } from 'react-router';
import { convertSearchUrl, getFilterFromUrl } from 'utils/tools';
import { omit } from 'lodash-es';
import ViewModeSwitcher from 'components/common/ViewModeSwitcher';
import {
  DEFAULT_CURRENT_PAGE,
  DEFAULT_LIMIT_ITEM,
} from 'configs/localData/constant';
import FilterCustom from '../components/FilterCustom';

interface Props {
  activeTab?: string;
  refresh?: () => void;
}

const HeaderFilter = ({ activeTab, refresh }: Props) => {
  const { push } = useHistory();
  const { search } = useLocation();
  const { filter: query } = getFilterFromUrl(search);

  const onChange = (e) => {
    const filter = {
      ...query,
      page: DEFAULT_CURRENT_PAGE,
      size: DEFAULT_LIMIT_ITEM,
    };
    push({
      pathname: `/contacts/${e.target.value}`,
      search: `?${convertSearchUrl(omit(filter, 'page'))}`,
    });
  };

  return (
    <div>
      <Row gutter={24}>
        <Col xxl={4} xl={4} lg={6} md={24} xs={24}>
          <ViewModeSwitcher onChange={onChange} activeTab={activeTab} />
        </Col>
        <Col xxl={20} xl={20} lg={18} md={24} xs={24}>
          <FilterCustom refresh={refresh} />
        </Col>
      </Row>
    </div>
  );
};

export default HeaderFilter;
